import * as React from "react";
import { useState, useEffect } from "react";
import userIcon from "../../../../../assets/images/icons/user1.png";
import mailIcon from "../../../../../assets/images/icons/mail.png";
import phoneIcon from "../../../../../assets/images/icons/phone.png";
import { getCorporates } from "src/services/corporateService";
import { createCorporate } from "src/services/corporateService";
import { AuthService } from "src/app/authentication/auth.service";
import { updateCorporate } from "src/services/corporateService";
import { deleteCorporate } from "src/services/corporateService";
import {getProjectsForUser, getUsersOfCorporate} from "src/services/corporateService";
import { useHistory } from "react-router-dom";
import { validatePhoneNumber } from "../../../../polar-SAAS-Components/utilsNew";
import useStyleClasses from "src/app/polar-SAAS-Components/style";
import Loader from "src/app/polar-SAAS-Components/components/Loader";
import ConfirmationPopup from "src/app/polar-SAAS-Components/components/ConfirmationPopup";
import Toaster from "src/app/polar-SAAS-Components/components/Toaster";
import { useIsMobile } from "../../../../polar-SAAS-Components/utilsNew";

const AllCorporate = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [corporates, setCorporates] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [kitCounts, setKitCounts] = useState<{ [key: string]: number }>({});
  const [userCounts, setUserCounts] = useState<{ [key: string]: number }>({});

  const [projectCounts, setProjectCounts] = useState<{ [key: string]: number }>(
    {}
  );
  const [editingCorporate, setEditingCorporate] = useState<any | null>(null);
  const [corporateIdToDelete,setCorporIdToDelete]=useState("");
  const [confirmOpen,setConfirmOpen]=useState(false);

  const [openToaster,setopenToaster]=useState(false);
  const [msg,setMsg]=useState("");
  const [success,setSuccess]=useState(true);

  const history = useHistory();
    const styleClasses=useStyleClasses()

  const [formData, setFormData] = useState({
    corporateName: "",
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    brc: "",
    contactAddress: "",
  });
  
  const [formErrors, setFormErrors] = useState({
    contactPhone: "",
  });
  const [isCountLoading,setIsCountLoading]=useState(false);
  const isMobile = useIsMobile();
  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    const fetchData = async () => {
      try {
        const corpRes = await getCorporates();
        const corporatesData: any[] =
          corpRes && corpRes.content ? corpRes.content : [];
        if (!isMounted) return;
        setCorporates(corporatesData);

        const projectRes = await getProjectsForUser();
        const projectList: any[] =
          projectRes && projectRes.data&&projectRes.data.content ? projectRes.data.content : [];

        const projectCountMap: { [key: string]: number } = {};
        const kitCountMap: { [key: string]: number } = {};
        const userCountMap: { [key: string]: number } = {};

        setIsCountLoading(true);
        await Promise.all(
          corporatesData.map(async (corp: any) => {
            try {
              const userRes = await getUsersOfCorporate(corp.id);
              const users: any[] =
                userRes && userRes.content ? userRes.content : [];

              const filtered = users.filter(
                (u: any) =>
                  u.references.includes(corp.id) && u.status === "ACTIVE"
              );

              if (isMounted) userCountMap[corp.id] = filtered.length;
            } catch {
              if (isMounted) userCountMap[corp.id] = 0;
            }
          })
        );

        projectList.forEach((proj: any) => {
          const corpId = proj.corporateId;
          projectCountMap[corpId] = (projectCountMap[corpId] || 0) + 1;
          kitCountMap[corpId] =
            (kitCountMap[corpId] || 0) +
            (proj.kits && proj.kits.length ? proj.kits.length : 0);
        });

        if (isMounted) {
          setProjectCounts(projectCountMap);
          setKitCounts(kitCountMap);
          setUserCounts(userCountMap);
        }
      } catch (err) {
        if (isMounted)
          console.error(" Failed to load corporates/projects", err);
      } finally {
        if (isMounted) setLoading(false);
        setIsCountLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false; // Cleanup flag
    };
  }, []);

  const getAccountId = () => {
    return AuthService.getAccount() || "default-account-id";
  };


  const handleDelete = async () => {
    try {
      setLoadingScreen(true);
      await deleteCorporate(corporateIdToDelete);
      setActiveMenu(null); 
      setMsg("Corporate deleted successfully.");
      setSuccess(true)
      setConfirmOpen(false);
      setopenToaster(true);
      setCorporates((prev) => prev.filter((corp) => corp.id !== corporateIdToDelete));
      setTimeout(function() {
        setLoadingScreen(false);
        setopenToaster(false);
      }, 5000);
    } catch (error) {
      console.error("Failed to delete corporate:", error);
      setMsg("Failed to delete corporate. Please try again.");
      setSuccess(false)
      setopenToaster(true);
      setConfirmOpen(false);
      setTimeout(function() {
        setLoadingScreen(false);
        setopenToaster(false);
      }, 5000);
    }

  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest(".menu-container")) {
        setActiveMenu(null);
      }
    };
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const filteredCorporates = corporates.filter((corporate) =>
    [
      corporate.name,
      corporate.contactName,
      corporate.contactEmail,
      corporate.contactPhoneNumber,
    ]
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    
    if (name === 'contactPhone') {
      // Allow only numbers, +, and spaces
      
      const validationResult = validatePhoneNumber(value);
      setFormErrors(prev => ({
        ...prev,
        contactPhone: validationResult.message
      }));
      
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = async () => {
    // Validate phone number before submitting
    const phoneValidation = validatePhoneNumber(formData.contactPhone);
    if (!phoneValidation.isValid) {
      setFormErrors(prev => ({
        ...prev,
        contactPhone: phoneValidation.message
      }));
      return;
    }

    try {
      const payload = {
        accountId: getAccountId(),
        name: formData.corporateName,
        contactName: formData.contactName,
        contactEmail: formData.contactEmail,
        contactPhoneNumber: formData.contactPhone,
        brc: formData.brc,
        contactAddress: formData.contactAddress,
      };
      setLoading(true);
      if (editingCorporate) {
        const updated = await updateCorporate(editingCorporate.id, payload);
        setCorporates((prev) =>
          prev.map((corp) => (corp.id === editingCorporate.id ? updated.data.content : corp))
        );
        setEditingCorporate(null);
      } else {
        const response = await createCorporate(payload);
        setCorporates((prev) => [...prev, response.data.content]);
      }

      setShowModal(false);
      setLoading(false);
      setFormData({
        corporateName: "",
        contactName: "",
        contactEmail: "",
        contactPhone: "",
        brc: "",
        contactAddress: "",
      });
    } catch (error) {
      console.error(" Failed to save corporate:", error);
      setMsg("Failed to save corporate. Please try again.");
      setSuccess(false)
      setLoading(false);
      setopenToaster(true);
      setTimeout(function() {
        setopenToaster(false);
      }, 5000);
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setFormData({
      corporateName: "",
      contactName: "",
      contactEmail: "",
      contactPhone: "",
      brc: "",
      contactAddress: "",
    });
  };
const handleNavigateProjects = (corporateId,corporateName)=>{
   props.setCorporateName(corporateName)
   history.push(`/projects?corporateId=${corporateId}`);


}
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest(".menu-container")) {
        setActiveMenu(null);
      }
    };
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <>
      <div className="container-react">
        <div className="header">
          <div className="search-filter-section">
            <div className="search-container-react">
              <input
                type="text"
                className="search-input-react"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span className="search-icon-react">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4733 13.5266L11.9999 11.0733C12.96 9.87621 13.4249 8.3568 13.2991 6.82747C13.1733 5.29814 12.4664 3.87512 11.3236 2.85103C10.1808 1.82694 8.68914 1.27961 7.15522 1.32158C5.62129 1.36356 4.16175 1.99164 3.0767 3.0767C1.99164 4.16175 1.36356 5.62129 1.32158 7.15522C1.27961 8.68914 1.82694 10.1808 2.85103 11.3236C3.87512 12.4664 5.29814 13.1733 6.82747 13.2991C8.3568 13.4249 9.87621 12.96 11.0733 11.9999L13.5266 14.4533C13.5886 14.5158 13.6623 14.5654 13.7436 14.5992C13.8248 14.633 13.9119 14.6505 13.9999 14.6505C14.0879 14.6505 14.1751 14.633 14.2563 14.5992C14.3376 14.5654 14.4113 14.5158 14.4733 14.4533C14.5934 14.329 14.6606 14.1628 14.6606 13.9899C14.6606 13.817 14.5934 13.6509 14.4733 13.5266ZM7.33327 11.9999C6.41029 11.9999 5.50804 11.7262 4.74061 11.2135C3.97318 10.7007 3.37504 9.97185 3.02183 9.11913C2.66862 8.2664 2.57621 7.32809 2.75627 6.42285C2.93634 5.5176 3.38079 4.68608 4.03344 4.03344C4.68608 3.38079 5.5176 2.93634 6.42285 2.75627C7.32809 2.57621 8.2664 2.66862 9.11913 3.02183C9.97185 3.37504 10.7007 3.97318 11.2135 4.74061C11.7262 5.50804 11.9999 6.41029 11.9999 7.33327C11.9999 8.57095 11.5083 9.75793 10.6331 10.6331C9.75793 11.5083 8.57095 11.9999 7.33327 11.9999Z"
                    fill="#324054"
                  />
                </svg>
              </span>
            </div>

            {/* filter requirment not defined yet . by account or which criteria  TODO 1 */}
            {/* <button className="filter-btn">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6663 2H1.33301L6.66634 8.30667V12.6667L9.33301 14V8.30667L14.6663 2Z"
                  stroke="#324054"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Filter
            </button> */} 
          </div>
          <button
            className="add-btn-dashboard"
            onClick={() => setShowModal(true)}
          >
            + {isMobile ? "" : "Add Corporates"}
          </button>
        </div>

        <div className="grid-container">
          <div className="corporates-grid">
            {filteredCorporates.map((corporate) => (
              <div key={corporate.id} className="corporate-card">
                <div className="card-headers">
                  {corporate.status=="ACTIVE"?<h3 className="company-name">{corporate.name}</h3>:
                <h3 className="company-name-inactive">{(corporate.name&&corporate.name.length>0)?corporate.name:"Unnamed Corporate"} <span className="corporate-inactive"> {`[INACTIVE]`}</span></h3>
                  }
                  <div className="menu-container">
                    <span
                      className="menu-dots"
                      onClick={(e) => {
                        e.stopPropagation();
                        setActiveMenu(
                          activeMenu === corporate.id ? null : corporate.id
                        );
                      }}
                    >
                      ⋮
                    </span>
                    {activeMenu === corporate.id && (
                      <div className="dropdown-menu">
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            setEditingCorporate(corporate);
                            setFormData({
                              corporateName: corporate.name || "",
                              contactName: corporate.contactName || "",
                              contactEmail: corporate.contactEmail || "",
                              contactPhone: corporate.contactPhoneNumber || "",
                              brc: corporate.brc || "",
                              contactAddress: corporate.contactAddress || "",
                            });
                            setShowModal(true);
                            setActiveMenu(null);
                          }}
                        >
                          Edit
                        </button>
                        <button className="dropdown-item">Settings</button>
                        <button
                          className="dropdown-item delete"
                          onClick={() => {setCorporIdToDelete(corporate.id);setConfirmOpen(true);}}
                        >
                          Delete
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="contact-info">
                  <div className="contact-item">
                    <div className="contact-icon">
                      <img
                        src={userIcon}
                        width="22"
                        height="22"
                        alt="User Icon"
                        className="contact-icon"
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                    </div>
                    <span>{corporate.contactName || "N/A"}</span>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">
                      <img
                        src={mailIcon}
                        width="22"
                        height="22"
                        alt="User Icon"
                        className="contact-icon"
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                    </div>
                    <span>{corporate.contactEmail || "N/A"}</span>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">
                      <img
                        src={phoneIcon}
                        width="22"
                        height="22"
                        alt="User Icon"
                        className="contact-icon"
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                    </div>
                    <span>{corporate.contactPhoneNumber || "N/A"}</span>
                  </div>
                </div>
                <div className="stats-row">
                  <span
                    style={styleClasses.countBox}
                    onClick={() =>
                      history.push(`/user-setting?corporateId=${corporate.id}`)
                    }
                  >
                    {isCountLoading?"Loading...":(userCounts[corporate.id] || 0)+" Users Available"}
                  </span>
                  <span
                    style={styleClasses.countBox}
                    onClick={() => handleNavigateProjects(corporate.id,corporate.name)
                     
                    }
                  >
                    {isCountLoading?"Loading...":(projectCounts[corporate.id] || 0)+ " Projects Available"}
                  </span>
                  <span
                    style={styleClasses.countBox}
                    onClick={() =>
                      history.push(`/kits?corporateId=${corporate.id}`)
                    }
                  >
                    {isCountLoading?"Loading...":(kitCounts[corporate.id] || 0)+" Entities Available"}
                  </span>
                </div>
                {/* <div className="card-footer">
                  <div className="warning-section">
                    {corporate.devicesNotWorking>0 && (
                      <span className="warning-icon">
                      <img
                        src={warnIcon}
                        width="16"
                        height="16"
                        alt="Warn Icon"
                        className="contact-icon"
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                    </span>)}
                    <span>
                     {corporate.devicesNotWorking>0&& <>{corporate.devicesNotWorking} devices not working</>}
                    </span>
                  </div>
                  <span className="device-count">
                    [ {corporate.totalDevices > 0 ? `${corporate.totalDevices} devices` : "No devices"}]
                  </span>
                </div> */}
              </div>
            ))}
          </div>
          <Loader isLoading={loading} fullScreen={false} />
        </div>

        {showModal && (
          <div className="model-overlay" onClick={handleCancel}>
            <div className="model" onClick={(e) => e.stopPropagation()}>
              <div className="model-header">
                <h2 className="model-title">CREATE CORPORATE</h2>
                <button className="close-btn" onClick={handleCancel}>
                  ×
                </button>
              </div>
              <div className="model-body">
                <div className="form-group">
                  <label className="form-labal">
                    Corporate Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="Enter corporate name here"
                    name="corporateName"
                    value={formData.corporateName}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-labal">
                    Contact Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="Enter contact name here"
                    name="contactName"
                    value={formData.contactName}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-labal">
                    Contact Email <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-input"
                    placeholder="example@gmail.com"
                    name="contactEmail"
                    value={formData.contactEmail}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-row">
                  <div className="form-group half">
                    <label className="form-labal">
                      Contact Phone Number <span className="required">*</span>
                    </label>
                    <input
                      type="tel"
                      className={`form-input ${formErrors.contactPhone ? 'invalid' : ''}`}
                      placeholder="eg: +94 xx xx xx"
                      name="contactPhone"
                      value={formData.contactPhone}
                      onChange={handleInputChange}
                    />
                    {formErrors.contactPhone && (
                      <span style={styleClasses.errorText}>
                        {formErrors.contactPhone}
                      </span>
                    )}
                  </div>
                  <div className="form-group half">
                    <label className="form-labal">
                      BRC <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Enter BRC here"
                      name="brc"
                      value={formData.brc}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-labal">
                    Contact Address <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-input"
                    placeholder="Enter contact address here"
                    name="contactAddress"
                    value={formData.contactAddress}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="model-footer">
                <button className="ktn btn-secondary" onClick={handleCancel}>
                  Cancel
                </button>
                <button className="ktn btn-primary" onClick={handleSubmit}>
                  {editingCorporate ? "Update Corporate" : "Add Corporate"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Loader isLoading={loadingScreen} fullScreen={true} />
      <ConfirmationPopup 
        open={confirmOpen}
        message="Are you sure you want to delete this Corporate?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={handleDelete}
        onCancel={() => setConfirmOpen(false)}
        isDanger={true} />
      <Toaster open={openToaster} isSuccess={success} msg={msg}/>
    </>
  );
};

export default AllCorporate;
